<template>
  <v-dialog v-model="dialog" persistent>
    <v-card>
      <v-toolbar color="white" fixed>
        <v-toolbar-title>
          <v-icon>mdi-account-group</v-icon>
          {{ $i18n.t("Select Customer") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="2">
            <v-text-field :label="$i18n.t('Name')" class="purple-input" v-model="name" />
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field :label="$i18n.t('Email')" class="purple-input" v-model="email" />
          </v-col>
          <v-col cols="12" md="1">
            <z-country-select
              :label="$i18n.t('ISD')"
              class="purple-input"
              v-model="countryCode"
              isd
              hideName
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field :label="$i18n.t('Phone')" class="purple-input" v-model="phone" />
          </v-col>

          <v-col cols="12" md="2">
            <z-client-select class="purple-input" v-model="client"></z-client-select>
          </v-col>
          <z-entity-select
            class="purple-input col-md-2 col-12"
            v-model="entity"
            corp="client"
            v-if="client != '' && client != null"
          ></z-entity-select>

          <v-spacer />
          <v-col cols="12" md="2" class="py-4">
            <v-btn
              color="success"
              class="float-right"
              fab
              x-small
              dark
              @click="search()"
              :loading="loading"
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
            <v-tooltip top class="float-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  class="float-right"
                  color="black"
                  text
                  fab
                  x-small
                  @click="clear(1)"
                  style="margin-right:2px !important"
                  v-on="on"
                >
                  <v-icon>mdi-cached</v-icon>
                </v-btn>
              </template>
              <span>{{ $i18n.t("Clear Filter") }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text>
        <v-btn
          v-if="!grid.records"
          class="text-center secondary--text pa-10"
          text
          color="primary"
          style="width:100%"
          :loading="loading"
        >{{ $i18n.t("No records available") }}</v-btn>

        <v-simple-table dense v-if="grid.records">
          <thead>
            <tr>
              <th class="primary--text">{{ $i18n.t("Name") }}</th>
              <th class="primary--text">{{ $i18n.t("Email") }}</th>
              <th class="primary--text">{{ $i18n.t("Phone") }}</th>
              <th class="primary--text">{{ $i18n.t("Gender") }}</th>
              <th class="primary--text">{{ $i18n.t("Designation") }}</th>
              <th class="primary--text">{{ $i18n.t("Department") }}</th>
              <!-- <th class="primary--text">{{ $i18n.t("Address") }}</th> -->
              <!-- <th class="primary--text">{{ $i18n.t("City") }}</th> -->
              <!-- <th class="primary--text">{{ $i18n.t("Country") }}</th> -->
              <th class="text-right primary--text">{{ $i18n.t("Action") }}</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="customer in grid.rows" :key="customer._id">
              <td>{{ customer.name }}</td>
              <td>{{ customer.email }}</td>
              <td>+{{ customer.user.countryCode }} {{ customer.user.phone }}</td>
              <td>{{ getGender(customer.user.gender) }}</td>
              <td>{{ customer.designation }}</td>
              <td>{{ customer.dept }}</td>
              <td>
                <!-- <z-confirm-button
                  class="float-right"
                  color="red lighten-1"
                  small
                  fab
                  text
                  dark
                  :loading="loading"
                  :message="$i18n.t('Do you want to delete this Customer ?')"
                  @click="deleteCustomer(customer)"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </z-confirm-button>-->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="float-right"
                      color="primary"
                      small
                      fab
                      text
                      dark
                      v-on="on"
                      @click="select(customer)"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
        <v-pagination
          v-if="grid.records"
          v-model="grid.page"
          class="my-4"
          :length="grid.total"
          total-visible="10"
          @input="showPage"
        ></v-pagination>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
        <v-btn color="blue darken-1" text @click="dialog = false">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "CustomerSelect",
  props: {
    value: {
      default: false,
    },
    corp: {
      default: null,
    },
  },
})
export default class CustomerSelect extends (Vue, Themeable) {
  grid = {};
  url = "/api/employee/data/grid?rows=20";
  name = "";
  email = "";
  filterUrl = "";
  countryCode = "";
  phone = "";
  client = "";
  entity = "";
  on = null;
  page = 1;
  dialog = false;
  selected = [];

  get loading() {
    return common.loading;
  }

  async mounted() {
    if (this.corp != null) {
      this.client = this.corp;
    }
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
    this.dialog = this.value === true;
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.name = "";
    this.email = "";
    this.client = "";
    this.entity = "";
    this.countryCode = "";
    this.phone = "";
    this.page = 1;
    this.search();
  }

  select(customer) {
    const response = {
      name: customer.name,
      email: customer.email,
      designation: customer.designation,
      dept: customer.dept,
      countryCode: customer.user.countryCode,
      phone: customer.user.phone,
      gender: customer.user.gender,
      residence: customer.user.residence,
    };
    this.$emit("select", [response]);
    this.dialog = false;
  }

  // selectThis(customer) {
  //   console.log(customer);
  //   customer["selected"] = !customer["selected"];
  //   if (customer["selected"]) {
  //     if (this.selected.filter((c) => c._id === customer._id).length == 0) {
  //       this.selected.push(customer);
  //     }
  //   } else {
  //     for (let i = 0; i < this.selected.length; i++) {
  //       if (this.selected[i]._id === customer._id) {
  //         this.selected.splice(i, 1);
  //         break;
  //       }
  //     }
  //   }
  // },
  // isSelected(customer) {
  //   if (customer != null && customer._id != null) {
  //     if (this.selected.filter((c) => c._id === customer._id).length > 0) {
  //       return true;
  //     }
  //   }
  //   return false;
  // },

  async search() {
    let filterUrl = "";
    if (this.name) filterUrl += "&name=" + this.name;
    if (this.email) filterUrl += "&email=" + this.email;
    if (this.countryCode) this.filterUrl += "&countryCode=" + this.countryCode;
    if (this.phone) filterUrl += "&phone=" + this.phone;
    if (this.client) filterUrl += "&corp_id=" + this.client;
    if (this.entity) filterUrl += "&entity_id=" + this.entity;
    this.filterUrl = filterUrl;
    common.setLoading(true);
    await this.showPage(1);
  }

  tableHeight() {
    return window.innerHeight - 400 + "px";
  }

  @Watch("value", { immediate: true })
  onValueChange(val) {
    this.dialog = val === true;
    this.$emit("input", val === true);
  }

  @Watch("dialog", { immediate: true })
  onDialogChange(val) {
    this.$emit("input", val === true);
  }

  getGender(val) {
    if (val === 1) {
      return this.$i18n.t("Male");
    } else if (val === 0) {
      return this.$i18n.t("Female");
    } else {
      return this.$i18n.t("Other");
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
.v-dialog > .v-card > .v-card__text {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-card .v-card__actions {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-dialog .v-card .v-card__title {
  padding-top: 10px;
}
</style>
